export default {
    urlGetAll: "/api/v1/financial/bank-reconciliation/get-all",
    urlGetAllRecord: "/api/v1/financial/bank-reconciliation/get-all-record",
    urlImportOfx: "/api/v1/financial/bank-reconciliation/import-ofx",
    urlImportOpenFinance: "/api/v1/financial/bank-reconciliation/import-open-finance",
    urlConfirm: "/api/v1/financial/bank-reconciliation/confirm",
    urlCreatePayableReceivable: "/api/v1/financial/bank-reconciliation/create-payable-receivable",
    urlDelete: "/api/v1/financial/bank-reconciliation/delete",
};
